var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8959 1.74622C12.1699 1.43562 12.1403 0.961674 11.8297 0.687622C11.5191 0.413569 11.0452 0.443191 10.7711 0.753784L11.8959 1.74622ZM4.4585 9.04167L3.89612 9.53788C4.03849 9.69924 4.24331 9.79167 4.4585 9.79167C4.67368 9.79167 4.8785 9.69924 5.02087 9.53788L4.4585 9.04167ZM1.89587 5.00378C1.62182 4.69319 1.14787 4.66357 0.83728 4.93762C0.526687 5.21167 0.497065 5.68562 0.771118 5.99622L1.89587 5.00378ZM10.7711 0.753784L3.89612 8.54545L5.02087 9.53788L11.8959 1.74622L10.7711 0.753784ZM5.02087 8.54545L1.89587 5.00378L0.771118 5.99622L3.89612 9.53788L5.02087 8.54545Z",
    fill: "#59AD78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDone);
export default __webpack_public_path__ + "static/media/status-done.916421f0c4725cec752e9b797393e283.svg";
export { ForwardRef as ReactComponent };